import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { NavigationProvider } from "@ploy-ui/template-form";
import { generatePath, useNavigate } from "react-router-dom";
import { createSearchParams } from "@ploy-lib/routing";
export function RouteNavigationProvider(props) {
    const { children, home = "/", application = "application/:applicationNumber", applicationWithStep = "application/:applicationNumber/*", applicationFromCalculator = ":category/:externalCode" } = props;
    const navigate = useNavigate();
    const value = useMemo(() => ({
        home: () => navigate({ pathname: home }),
        application: (applicationNumber, fromSubmit = false, customerContext = "") => navigate({
            pathname: generatePath(application, { applicationNumber }),
            search: createSearchParams({
                fromSubmit: fromSubmit ? fromSubmit : undefined
            })
        }),
        applicationWithStep: (applicationNumber, step, fromSubmit = false, customerContext = "") => navigate({
            pathname: generatePath(applicationWithStep, {
                applicationNumber,
                "*": step
            }),
            search: createSearchParams({
                fromSubmit: fromSubmit ? fromSubmit : undefined
            })
        }),
        applicationFromCalculator: (category, externalCode) => navigate({
            pathname: generatePath(applicationFromCalculator, {
                category,
                externalCode
            })
        })
    }), [
        application,
        applicationFromCalculator,
        applicationWithStep,
        home,
        navigate
    ]);
    return _jsx(NavigationProvider, { value: value, children: children });
}
//# sourceMappingURL=RouteNavigationProvider.js.map